import React, { useEffect, useState } from 'react';
import api from '../../api';

const SECTION_LABELS = {
  hero: 'Inicio (Hero)',
  about: 'Sobre Nosotros',
  services: 'Niveles Educativos',
  gallery: 'Galería',
  contact: 'Contacto',
  footer: 'Pie de Página',
};

const FIELD_LABELS = {
  title: 'Título',
  subtitle: 'Subtítulo',
  cta_text: 'Texto del botón',
  description: 'Descripción',
  mission_title: 'Título Misión',
  mission: 'Misión',
  vision_title: 'Título Visión',
  vision: 'Visión',
  values_title: 'Título Valores',
  values: 'Valores',
  item1_title: 'Título Preescolar',
  item1_desc: 'Descripción Preescolar',
  item1_icon: 'Icono Preescolar',
  item2_title: 'Título Primaria',
  item2_desc: 'Descripción Primaria',
  item2_icon: 'Icono Primaria',
  item3_title: 'Título Bachillerato',
  item3_desc: 'Descripción Bachillerato',
  item3_icon: 'Icono Bachillerato',
  address: 'Dirección',
  phone: 'Teléfono',
  email: 'Correo',
  schedule: 'Horario',
  text: 'Texto',
};

function AdminContent() {
  const [content, setContent] = useState({});
  const [saving, setSaving] = useState({});
  const [saved, setSaved] = useState({});

  useEffect(() => {
    api.get('/content').then(r => setContent(r.data)).catch(() => {});
  }, []);

  const handleChange = (section, key, value) => {
    setContent(prev => ({
      ...prev,
      [section]: { ...prev[section], [key]: value }
    }));
  };

  const saveSection = async (section) => {
    setSaving(s => ({ ...s, [section]: true }));
    try {
      const updates = Object.entries(content[section] || {}).map(([field_key, field_value]) => ({
        section, field_key, field_value
      }));
      await api.put('/content/bulk', { updates });
      setSaved(s => ({ ...s, [section]: true }));
      setTimeout(() => setSaved(s => ({ ...s, [section]: false })), 2000);
    } catch {}
    setSaving(s => ({ ...s, [section]: false }));
  };

  const sections = Object.keys(SECTION_LABELS);

  return (
    <>
      <div className="admin-topbar"><h1>Gestión de Contenido</h1></div>
      <div className="admin-content">
        {sections.map(section => (
          <div key={section} className="admin-card">
            <h3>{SECTION_LABELS[section]}</h3>
            {Object.entries(content[section] || {}).map(([key, value]) => (
              <div key={key} className="field-group">
                <label>{FIELD_LABELS[key] || key}</label>
                {value.length > 80 ? (
                  <textarea
                    value={value}
                    onChange={e => handleChange(section, key, e.target.value)}
                    rows={3}
                  />
                ) : (
                  <input
                    type="text"
                    value={value}
                    onChange={e => handleChange(section, key, e.target.value)}
                  />
                )}
              </div>
            ))}
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '0.5rem' }}>
              <button className="btn-save" onClick={() => saveSection(section)} disabled={saving[section]}>
                <span className="material-icons" style={{ fontSize: '1rem' }}>save</span>
                {saving[section] ? 'Guardando...' : 'Guardar'}
              </button>
              {saved[section] && <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 500 }}>Guardado correctamente</span>}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default AdminContent;
